import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { SchoolLicenseUpgradeRequested } from '../../../ampli';
import { getProductByLicenceModelId, schoolLicences } from '../../../constants';
import { selectSelectedSchoolId } from '../../../reducers/user.selectors';
import services from '../../../services';
import schoolService from '../../../services/school.service';
import { SnackbarContext } from '../../../state/SnackbarContextProvider';

export const useRequestUpgradeProducts = () => {
	const { t } = useTranslation();
	const { openSnackbar } = useContext(SnackbarContext);
	const schoolSeats = useSelector((state: any) => state.user.schoolSeats);
	const selectedSchoolId = useSelector(selectSelectedSchoolId);

	const showError = (message: string) => {
		openSnackbar({
			type: 'error',
			message,
		});
	};

	const showInfo = (message: string) => {
		openSnackbar({
			type: 'success',
			message,
		});
	};

	const handleRequestUpgradeProducts = async (requestedProducts: string[]) => {
		if (!requestedProducts?.length) return;

		const errorMessage = t(
			'There was an error sending your request. Please try again later, or contact ' +
				'support schulen@meinunterricht.de'
		);

		try {
			if (!selectedSchoolId) {
				showError(errorMessage);
				return;
			}

			if (schoolSeats) {
				const products: string[] = [];
				if (schoolSeats.bibliothekSeats.available > 0) {
					products.push(getProductByLicenceModelId(schoolLicences.MU_PRO)?.ampliName ?? '');
				}
				if (schoolSeats.courseSeats.available > 0) {
					products.push(getProductByLicenceModelId(schoolLicences.COURSE)?.ampliName ?? '');
				}
				if (schoolSeats.kombiSeats.available > 0) {
					products.push(getProductByLicenceModelId(schoolLicences.KOMBI)?.ampliName ?? '');
				}

				services.track.ampliEventTrack({
					event: new SchoolLicenseUpgradeRequested({
						'school id': selectedSchoolId,
						'subscription products': products,
					}),
				});
			}

			const result = await schoolService.requestUpgradeProducts({
				schoolId: selectedSchoolId,
				requestedProducts,
			});

			if (result?.success) {
				showInfo(t('The contact person from meinUnterricht will get in touch shortly.'));
			} else {
				showError(errorMessage);
			}
		} catch {
			showError(errorMessage);
		}
	};

	return {
		handleRequestUpgradeProducts,
	};
};
